import request from '@/request/request'

// 查询喷灌设置列表
export function listSprinklingIrrigationSetting(query) {
    return request({
        url: '/api/equipment-server/sprinklingIrrigationSetting/list',
        method: 'get',
        params: query
    })
}

// 查询喷灌设置详细
export function getSprinklingIrrigationSettingById(id) {
    return request({
        url: '/api/equipment-server/sprinklingIrrigationSetting/' + id,
        method: 'get'
    })
}

// 新增喷灌设置
export function addSprinklingIrrigationSetting(data) {
    return request({
        url: '/api/equipment-server/sprinklingIrrigationSetting',
        method: 'post',
        data: data
    })
}

// 修改喷灌设置
export function updateSprinklingIrrigationSetting(data) {
    return request({
        url: '/api/equipment-server/sprinklingIrrigationSetting/edit',
        method: 'post',
        data: data
    })
}

// 删除喷灌设置
export function delSprinklingIrrigationSetting(id) {
    return request({
        url: '/api/equipment-server/sprinklingIrrigationSetting/delete/' + id,
        method: 'post'
    })
}

// 批量新增喷灌设置
export function batchUpdateSprinklingIrrigationSetting(data) {
    return request({
        url: '/api/equipment-server/sprinklingIrrigationSetting/batchUpdate',
        method: 'post',
        data: data
    })
}

